import React, { useState } from "react";
import "./UpgradeModal.css";
import Swal from "sweetalert2";
import { useEffect } from "react";

const UpgradeModal = ({ isOpen, onClose, tutor, setPlanStatus, fetchPlan }) => {



  const [selectedPlan, setSelectedPlan] = useState({
    name: "Monthly",
    price: 0,
    period: "monthly",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const plans = {
    monthly: { name: "Full term", price: 0, period: "monthly" },
    yearly: { name: "Monthly", price: 99, period: "yearly" },
  };

  const handlePlanSelect = (planKey) => {
    setError("");
    setSelectedPlan(plans[planKey]);
  };



    /*
const handleUpgrade = async () => {
  if (selectedPlan.price === 0) {
    await fetch("https://kalakakshaaha.com/kks/api/v1/free-plan", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tutor_id: tutor.user_id })
    });
    Swal.fire({ icon: "success", title: "Plan Activated", text: "You are now on the Free plan." });
    return;
  }

  const res = await fetch("https://kalakakshaaha.com/kks/api/v1/razorpay-initiate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      tutor_id: tutor.user_id,
      plan_name: selectedPlan.name
    })
  });

  const data = await res.json();

  if (!data.success) return;

  const options = {
    key: data.key,
    amount: data.amount,
    currency: "INR",
    name: "Kalakakshaaha",
    description: selectedPlan.name,
    order_id: data.order_id,

    handler: async function (response) {
      // VERIFY PAYMENT
      const verifyRes = await fetch("https://kalakakshaaha.com/kks/api/v1/razorpay-verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          order_id: data.order_id,
          payment_id: response.razorpay_payment_id,
          signature: response.razorpay_signature
        })
      });

      const verifyData = await verifyRes.json();

      if (verifyData.success) {
        Swal.fire("Success ", "Plan Activated", "success")
          .then(() => window.location.reload());
      } else {
        Swal.fire("Error", "Payment verification failed", "error");
      }
    },

    theme: {
      color: "#3399cc"
    }
  };
  if (!window.Razorpay) {
  Swal.fire("Error", "Razorpay failed to load. Please refresh the page.", "error");
  return;
}

  const rzp = new window.Razorpay(options);
  rzp.open();
};*/

const handleUpgrade = async () => {
  if (selectedPlan.price === 0) {
    await fetch("https://kalakakshaaha.com/kks/api/v1/free-plan", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tutor_id: tutor.user_id })
    });
    Swal.fire({ icon: "success", title: "Plan Activated", text: "You are now on the Free plan." });
    return;
  }

  const res = await fetch("https://kalakakshaaha.com/kks/api/v1/easebuzz-initiate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tutor_id: tutor.user_id, plan_name: selectedPlan.name })
  });

  const data = await res.json();

  if (data.success && data.payment_url) {
    const txnid = data.txnid; // ✅ need txnid from backend
    const paymentWindow = window.open(data.payment_url, "_blank");

    const interval = setInterval(async () => {
      try {
        const checkRes = await fetch(
          `https://kalakakshaaha.com/kks/api/v1/check-payment?tutor_id=${tutor.user_id}&txnid=${txnid}`
        );
        const checkData = await checkRes.json();

        if (checkData.paid) {
          clearInterval(interval);
          paymentWindow?.close();

          Swal.fire({
            icon: "success",
            title: "Plan Activated 🎉",
            text: "Your Premium plan is now active!",
          });

        
          setPlanStatus("premium");   // instant UI update
             // sync backend
          onClose();                  // close modal
        }
      } catch (e) {
        console.log("Polling...", e);
      }
    }, 3000);

    setTimeout(() => clearInterval(interval), 600000);
  }
};

  
  return (
    <div className="modal-backdrop">
      <div className="upgrade-modal-content">

        <button className="close-x" onClick={onClose}>
          &times;
        </button>

        <div className="upgrade-grid">

          {/* BASIC PLAN */}
          <div
            className={`plan-column ${
              selectedPlan.period === "monthly" ? "selected" : ""
            }`}
            onClick={() => handlePlanSelect("monthly")}
          >

            <span className="plan-label">Full term</span>
            <h3>Basic</h3>

            <div className="price-tag">
              <span className="currency">₹</span>
              <span className="amount">Free</span>
            </div>

          </div>

          {/* PREMIUM PLAN */}
          <div
            className={`plan-column ${
              selectedPlan.period === "yearly" ? "selected" : ""
            }`}
            onClick={() => handlePlanSelect("yearly")}
          >

            <span className="plan-label">Monthly</span>
            <h3>Premium</h3>

            <div className="price-tag">
              <span className="currency">₹</span>
              <span className="amount">99</span>
              <span className="period"> / 3 Months</span>
            </div>

            <ul className="plan-features">
              <li className="active">Contact info</li>
              <li className="active">Social Media Visible</li>
              <li className="active">Demo Request Visible</li>
            </ul>

          </div>

          {/* CHECKOUT */}
          <div className="checkout-column">

            <h4>Upgrade to {selectedPlan.name}</h4>

            <div className="summary-row">
              <span>Plan Total</span>
              <span>₹ {selectedPlan.price}</span>
            </div>

            <div className="summary-row">
              <span>Taxes & Fees</span>
              <span>₹ 0</span>
            </div>

            <div className="total-pay">
              <span>Amount To Pay</span>
              <span>₹ {selectedPlan.price}</span>
            </div>

            {error && <p className="error-text">{error}</p>}

          <button
            className="payment-method-btn"
            disabled={loading || selectedPlan.price === 0}
            onClick={handleUpgrade}
          >
            {selectedPlan.price === 0
              ? "Free Plan Selected"
              : loading
              ? "Processing..."
              : "Proceed to Payment"}
          </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;